import * as React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { createStructuredSelector } from 'reselect';
import { CommandBar, ICommandBarItemProps } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { DocumentActions as UiDocumentActions} from '../../../redux/actions/ui';
import { CommandActions as DocumentCommandActions} from '../../../redux/actions/document';
import { CommandActions as DocumentsCommandActions} from '../../../redux/actions/documents';
import {Actions as ModalActions} from '@pwbapps/genericdialog';
import _ from 'lodash'
import { getFilterPanelOpened } from '../../../redux/reducers/ui';
import { getTotal } from '../../../redux/reducers/documents';
import { getStatusValues } from '../../../redux/reducers/sharedData';
import { Status } from '../../../models/status';
import { InternalRoleActionsType, ExternalRoleActionsType, isExternalApp } from '../../../utils/costants';
import { getSelectedProject } from '../../../redux/selectors/project';
import { Project } from '../../../models/project';
import { getContextualDocuments, getSelectedDocument } from '../../../redux/selectors/documents';
import { Document, getChangeStatusEmptyFileForm, getEmptyFileForm } from '../../../models/document';
import { withTranslation, WithTranslation  } from 'react-i18next';

export interface ContactsProps extends WithTranslation  {
    filterPanelOpened: boolean, 
    documents: Document[],
    selectedDocument?: Document,
    total: number,
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    statusValues: Status[],
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    selectedProject?: Project,
    setFilterPanelOpened: typeof UiDocumentActions.setFilterPanelOpened,
    setOpenModal: typeof DocumentCommandActions.setOpenModal,
    openGenericModal: typeof ModalActions.CommandActions.openModal,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    openEditModal: typeof DocumentsCommandActions.openEditModal,
}

class DocumentsCommandBar extends React.Component<ContactsProps> {
    constructor(props: ContactsProps) {
        super(props);
    }   


    getButtons = () => {
        const { documents, total, selectedDocument, openGenericModal, loadingContent, loading, loadingScroll, statusValues, userProjectActions, t, fetchDocuments, openEditModal } = this.props;
        let buttons: ICommandBarItemProps[] = [];
        let readyForPublishStatus = _.find(statusValues, a => a.name === 'ready-for-publishing') as Status;
        let partenrReservedStatus = _.find(statusValues, a => a.name === 'partner-reserved') as Status;
        let selectedDocumentIds = _.map(documents, d => d.id as number);
        const commentsExist = (documents && documents.length > 0) ? _.some(documents, d => d.comments && d.comments.length > 0) : true;
        buttons = [        
            ...((_.find(userProjectActions, a => a === 'ReadyForPublishQualityCheck')) ? [{
                key: 'ready-for-publishing',
                name: t('Ready for publishing'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...readyForPublishStatus}, fileForm: getChangeStatusEmptyFileForm()}})},
                iconProps: {
                    iconName: (readyForPublishStatus) ? readyForPublishStatus.icon : undefined,
                    style: {color: (readyForPublishStatus) ? readyForPublishStatus.color : undefined} 
                }
            }] : []),
            ...((_.find(userProjectActions, a => a === 'DeclineQualityCheck')) ? [{
                key: 'decline',
                name: t('Decline'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'changeStatus', contextItem: {newStatus: {...partenrReservedStatus}, fileForm: getChangeStatusEmptyFileForm()}})},
                iconProps: {
                    iconName: (partenrReservedStatus) ? partenrReservedStatus.icon : undefined,
                    style: {color: (partenrReservedStatus) ? partenrReservedStatus.color : undefined} 
                }
            }] : []),    
            ...(_.find(userProjectActions, a => a === 'EditQualityCheck') ? [{
                key: 'editDocument',
                name: t('Edit'),
                disabled: (selectedDocumentIds.length === 0 || _.some(documents, d => !d.isCurrent || (d.status && d.status.name === 'canceled')) || loadingContent || loading || loadingScroll),
                onClick: () => {openEditModal()},
                iconProps: {
                    iconName: 'Edit'
                },
            }] : []), 
            ...(_.find(userProjectActions, a => a === 'UploadAttachmentQualityCheck' || a === 'UploadCommentFileQualityCheck') ? [{
                key: 'upload',
                name: t('Upload'),
                disabled: (selectedDocumentIds.length !== 1 || (selectedDocument && !selectedDocument.isCurrent) || (selectedDocument && selectedDocument.status && selectedDocument.status.name === 'canceled') || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'uploadDocuments', contextItem: {files: [], fileForm: getEmptyFileForm((_.find(userProjectActions, a => a === 'UploadAttachmentQualityCheck')) ? true : false, (_.find(userProjectActions, a => a === 'UploadCommentFileQualityCheck')) ? true : false)}})},
                iconProps: {
                    iconName: 'BulkUpload'
                },
            }] : []),   
            ...(_.find(userProjectActions, a => a === 'DeleteQualityCheck') ? [{
                key: 'delete',
                name: t('Delete'),
                disabled: (selectedDocumentIds.length === 0 || !(_.every(documents, d => d.isCurrent && d.status && (d.status.name === 'uploaded' || d.status.name === 'ready-for-publishing'))) || loadingContent || loading || loadingScroll),
                onClick: () => {openGenericModal({id: 'deleteDocument'})},
                iconProps: {
                    iconName: 'Cancel',
                    style: {color: "red"}
                },
            }] : []), 
            ...(_.find(userProjectActions, a => a === 'ReadQualityCheck') ? [{
                key: 'downlaod',
                name: t('Download'),
                disabled: (loadingContent || loading || loadingScroll),
                iconProps: {
                    iconName: t('Download'),
                },
                subMenuProps: {
                    items: [
                        {
                            key: 'downlaodFiles',
                            name: t('Files'),
                            disabled: (total === 0 || !_.some(documents, d => d.files.length > 0) || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'fileName', contextItem: {fileName: 'Documents Files', isParent: false}}) },
                            iconProps:  {
                                iconName: 'DownloadDocument'
                            } 
                        },
                        {
                            key: 'downloadComments',
                            name: t('Comments'),
                            disabled: (total === 0 || !commentsExist || loadingContent || loading || loadingScroll),
                            onClick: () => { openGenericModal({id: 'comments', optional: 'Documents Comments'}) },
                            iconProps: {
                                iconName: 'Comment',
                            },
                        }
                    ]
                }          
            }] : []),       
            ...(!isExternalApp || _.find(userProjectActions, a => a === 'ReserveNumbersDashboard') ? [{
                key: 'excelReport',
                name: t('Report'),
                disabled: (total === 0 || loadingContent || loading || loadingScroll),
                onClick: () => { openGenericModal({id: 'excelReport', optional: 'Documents Report'}) },
                iconProps: {
                    iconName: 'ExcelDocument',
                    style: {color: "#008000"}
                  },
            }] : []), 
            {
                key: 'refresh',
                name: t('Refresh'),
                disabled: (loadingContent || loading || loadingScroll),
                onClick: () => { fetchDocuments({}) },
                iconProps: {
                    iconName: 'Refresh',
                },
            }                           
        ]
        return buttons;
    };

    getFarButtons = () => {
      const {setFilterPanelOpened, filterPanelOpened, t} = this.props;
      return [
     
        {
          key: 'openPanel',
          name: t('Filters'),
          iconProps: {
            iconName: 'Filter'
          },
          ariaLabel: 'Filters',    
          onClick: () => {setFilterPanelOpened({open: !filterPanelOpened})}      
        },          
      ]; 
  };

    render() {
        const styles = getClassNames();
        return (
            <>
                <CommandBar
                    styles={{root: styles.root, secondarySet: {borderTop: 1}}}
                    items={this.getButtons()}
                    farItems={this.getFarButtons()}
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterPanelOpened: getFilterPanelOpened,
    documents: getContextualDocuments,
    total: getTotal,
    statusValues: getStatusValues,
    selectedProject: getSelectedProject,
    selectedDocument: getSelectedDocument,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setFilterPanelOpened: UiDocumentActions.setFilterPanelOpened,
        setOpenModal: DocumentCommandActions.setOpenModal,
        openGenericModal: ModalActions.CommandActions.openModal,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        openEditModal: DocumentsCommandActions.openEditModal,
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(DocumentsCommandBar));
